<form
  class="content"
  [formGroup]="form"
  (ngSubmit)="onBegin()"
>
  <header class="paragraph-content-header text-center mb-3">
    <h1 class="page-title">Hey, Camper!</h1>


  </header>

  <section class="text">

    <p class="p lato bold teal text-center">
      We're excited to get to know you
    </p>

    <p class="p lato teal text-center">
      Please take a moment to complete a profile for your dog. Learning about
      your pup helps us provide the highest levels of care and maximum tail
      wags.
    </p>
    <p class="p lato teal text-center">
      Add your dog's name and tap '<span style="color: #CD0000">Begin</span>' to get started!
    </p>
  </section>

  <div class="input-container">
    <span class="input-label">Dog Name</span>
    <input
      type="text"
      class="input"
      formControlName="firstName"
      role="form"
    />
    <!-- CBW-784 Names -->
    <span
      class="error"
      *ngIf="f.firstName.touched && f.firstName.value === ''"
    >Please enter pet name.</span>
  </div>

  <div style="margin-top: 5rem">
    <hr />
    <footer class="footer-action">
      <button
        type="submit"
        class="btn btn-danger btn-block"
        [disabled]="!form.valid"
      >
        Begin
      </button>
    </footer>
  </div>
</form>
